import { render, staticRenderFns } from "./CreateRelease.vue?vue&type=template&id=23968e8f&scoped=true"
import script from "./CreateRelease.vue?vue&type=script&lang=js"
export * from "./CreateRelease.vue?vue&type=script&lang=js"
import style0 from "./CreateRelease.vue?vue&type=style&index=0&id=23968e8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23968e8f",
  null
  
)

export default component.exports